export const handleValidateObj = (obj) => {
  return Object.values(obj).every((x) => x !== null && x !== '' && x !== ' ');
};
